import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34049798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { style: {"margin-block":"15px","display":"flex","justify-content":"center","align-items":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t("thankpage.thank")) + " ", 1),
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("welcome.bookingsuccess")) + " ", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("welcome.yourLink")) + " ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              style: {"font-size":"12px","text-decoration":"underline"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyURL(_ctx.room_link)))
            }, _toDisplayString(_ctx.room_link), 1)
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("welcome.yourTime")) + " " + _toDisplayString(_ctx.time), 1)
        ])
      ])
    ])
  ]))
}